import React, { useState } from "react";

const SearchBarWithSuggestions = ({
  suggestions,
  onSelect,
  onChange,
  value,
  placeholder,
  keyNames = [],
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleChange = (e) => {
    onChange(e.target.value);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (item) => {
    onSelect(item);
    setShowSuggestions(false);
  };

  // Function to render suggestion item dynamically based on keyNames
  const renderSuggestion = (item) => {
    if (!item) return "No data";
    // Create a string by concatenating values from keys provided in keyNames
    return keyNames.map((key) => item[key] || "N/A").join(" - ");
  };

  return (
    <div className="relative flex items-center justify-between space-x-4">
      <div className="block text-md font-medium text-white-300 w-1/2">
        <label className="block text-md font-medium text-white-300">
          {placeholder}
        </label>
      </div>
      <div className="w-1/2">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onFocus={() => setShowSuggestions(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 400)} // Delay to allow click event to register
          className="w-full px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder={placeholder}
        />
        {showSuggestions && suggestions.length > 0 && (
          <ul className="top-full left-0 mt-2 bg-white border border-gray-600 rounded-md shadow-lg z-10 w-1/2 h-[200px] overflow-scroll">
            {suggestions.map((item, index) => (
              <li
                key={index}
                onClick={() => handleSuggestionClick(item)}
                className="px-3 py-2 cursor-pointer hover:bg-gray-200"
              >
                {renderSuggestion(item)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SearchBarWithSuggestions;
